import { LdIcon, LdTypo } from "@emdgroup-liquid/liquid/dist/react";
import { PureSurveyLayout } from "layouts";

import { useSelector } from "store";
import { useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const AnswerResponse = () => {
  const { responseStatus } = useParams();
  const [searchParams, setSearchParams] =
    useState<{ message?: string; error?: string }>();
  const { state } = useLocation();

  const { error } = useSelector(({ survey }) => survey);

  useEffect(() => {
    if (state !== null) {
      const { searchParams: s } = state as {
        searchParams?: { message?: string; error?: string };
      };
      setSearchParams(s);
    }
  }, [state]);
  return (
    <PureSurveyLayout>
      <div className="container flex flex-col p-ld-32 items-center justify-center">
        {responseStatus === "success" && (
          <div className="flex flex-col items-center">
            <LdIcon
              name="checkmark"
              size="lg"
              className="text-wht bg-thm-success w-10 h-10 rounded-full mb-ld-16"
            />
            <LdTypo variant="cap-l">
              Thank you for providing your feedback
            </LdTypo>
            {searchParams?.message !== undefined && (
              <LdTypo variant="cap-m">{searchParams.message}</LdTypo>
            )}
          </div>
        )}
        {responseStatus === "error" && (
          <div className="flex flex-col items-center">
            <LdIcon
              size="lg"
              name="attention"
              className="text-wht bg-thm-error w-10 h-10 rounded-full mb-ld-16"
            />
            {searchParams?.error !== undefined ? (
              <LdTypo variant="cap-m">{searchParams.error}</LdTypo>
            ) : (
              <LdTypo variant="cap-m">{error}</LdTypo>
            )}
          </div>
        )}
      </div>
    </PureSurveyLayout>
  );
};

export default AnswerResponse;
